export const capitalize = <T extends string | null | undefined>(str: T) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
